import React from "react";
import ConstruccionDatosPaso2 from "../../components/CotizacionHogar/CotizacionConstruccionPaso2";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class ContainerCotizacionPaso2 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {    
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">                    
            <ConstruccionDatosPaso2/>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({  
});

const mapDispatchToProps = dispatch => {
  return {
    
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionPaso2)
);
